<template>
  <div>
    <div v-if="Matter" class="title-presentation">
      <div class="school-title w-50">
        {{ $getVisibleNames("mesh.faculty", false, "Facultad").toUpperCase() }}:
        {{ faculty ? faculty.name.toUpperCase() : "" }}
      </div>
      <div class="program-title w-50">
        {{ $getVisibleNames("mesh.career", false, "Programa").toUpperCase() }}:
        {{ careerFilter ? careerFilter.name.toUpperCase() : "" }}
      </div>
    </div>
    <div
      class="table-container"
      :class="{ 'table-container-odd': !isPairNumberTableHeader }"
    >
      <!-- Fila 1 -->
      <!-- Nombre -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{ $t("reusable.common.name").toUpperCase() }}
        </div>
        <div class="secundary-cell name-matter w-50">
          <span>{{ oldMatter.name.toUpperCase() }}</span>
        </div>
      </div>
      <!-- Codigo -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.matter_code",
              false,
              "Código"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell code-matter w-50">
          <span>
            {{
              oldMatter && oldMatter.code ? oldMatter.code.toUpperCase() : "N/A"
            }}
          </span>
        </div>
      </div>
      <!-- Codigo EPM -->
      <div
        v-if="
          institution &&
          institution.use_epm_code &&
          Matter &&
          Matter.code &&
          Matter.code !== oldMatter.code
        "
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.ep_matter_code",
              false,
              "Código"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell code-matter w-50">
          <span>
            {{ Matter && Matter.code ? Matter.code.toUpperCase() : "N/A" }}
          </span>
        </div>
      </div>
      <!-- Nivel del Plan -->
      <div v-if="Matter" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{ $t("matterProgram.matterProgramView.planLevel").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <span>{{ Matter.plan_level }}</span>
        </div>
      </div>

      <!-- Fila 2 -->

      <!-- Prerequisitos -->
      <div v-if="Matter" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $t("matterProgram.matterProgramView.prerequisite").toUpperCase()
          }}(S)
        </div>
        <div class="secundary-cell w-50">
          <p v-if="prerequisites.length == 0" class="prerequisites-p">
            {{ $t("matterProgram.matterProgramView.doesNotHave") }}
          </p>
          <div
            v-else
            :id="`prerequisite-label-${Matter.id}`"
            class="campus-container"
          >
            <span
              v-for="(prerequisite, index) in prerequisites"
              :key="'prerequisites' + index"
              class="kl-chip noprint"
              :style="{
                'background-color': matterFormationLine,
                color: $lightOrDark(matterFormationLine) ? '#2b2a2a' : 'white',
              }"
            >
              <span class="prerequisite-order">
                {{ prerequisite.order }}
              </span>
            </span>
            <span class="prerequisite-code">
              {{ prerequisites.map((x) => x.code).join(", ") }}
            </span>
            <PrerequisitesPopover
              v-if="prerequisites.length > 0"
              :object="Matter"
              :content="prerequisitesNames"
              :placement="'top'"
              :triggers="'hover'"
              :title="$t('matterProgram.matterProgramView.requirements')"
            >
            </PrerequisitesPopover>
          </div>
        </div>
      </div>

      <!-- Semanas -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{ $t("matterProgram.matterProgramView.weeks").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="Matter && !Matter.use_matter_values">
            <span>{{ Matter.weeks }}</span>
          </div>
          <div v-else>
            <span>{{ oldMatter.weeks }}</span>
          </div>
        </div>
      </div>
      <!-- Perfil de Egreso -->
      <div v-if="Matter" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="getEgressProfile">{{ getEgressProfile }}</span>
        </div>
      </div>

      <!-- Fila 3-->

      <!-- Linea de Formacion -->
      <div v-if="Matter" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.formationline",
              false,
              "Línea De Formación"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getFormationLine">
            <div>
              {{ getFormationLine.name }}
            </div>
          </template>
        </div>
      </div>
      <!-- N° Docentes -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $t("matterProgram.matterProgramView.numberOfTeachers").toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="Matter && !Matter.use_matter_values">
            {{
              Matter.suggested_teachers == null
                ? "0"
                : Matter.suggested_teachers
            }}
          </span>
          <span v-else>
            {{
              oldMatter.suggested_teachers == null
                ? "0"
                : oldMatter.suggested_teachers
            }}
          </span>
        </div>
      </div>
      <!-- N° Estudiantes -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $t("matterProgram.matterProgramView.numberOfStudents").toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="Matter && !Matter.use_matter_values">
            {{
              Matter.suggested_students == null
                ? "0"
                : Matter.suggested_students
            }}
          </span>
          <span v-else>
            {{
              oldMatter.suggested_students == null
                ? "0"
                : oldMatter.suggested_students
            }}
          </span>
        </div>
      </div>

      <!-- Eximible -->
      <div
        v-if="institution && institution.internal_use_id == 'iacc.cl'"
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{ $t("matterProgram.matterProgramView.isExemptable").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="Matter && !Matter.use_matter_values">
            {{
              Matter.is_exemptable
                ? $t("reusable.common.yes")
                : $t("reusable.common.no")
            }}
          </span>
          <span v-else>
            {{
              oldMatter.is_exemptable
                ? $t("reusable.common.yes")
                : $t("reusable.common.no")
            }}
          </span>
        </div>
      </div>

      <!-- Fila 4 -->

      <!-- Área de Formación -->
      <div v-if="!$hidesFormationArea(institution)" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.formationarea",
              false,
              "Área De Formación"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getFormationAreas">
            <div>
              {{ getFormationAreas.name }}
            </div>
          </template>
        </div>
      </div>
      <!-- Tipo de Asignatura -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.mattertype",
              false,
              "Tipo De Asignatura"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getMatterType.length > 0">
            <span>
              {{ getMatterType.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>{{ $t("reusable.common.notApplicable") }}</div>
          </template>
        </div>
      </div>
      <!-- Régimen -->
      <div v-if="Matter" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames("mesh.periodtype", false, "Régimen").toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <div v-if="getRegimen">
            {{ getRegimen.name }}
          </div>
        </div>
      </div>
      <!-- Estudiantes por Ambiente de Aprendizaje OldMatter-->
      <template
        v-if="
          oldMatter &&
          selectedStudyEnvironmentsOldMatter.length > 0 &&
          Matter &&
          Matter.use_matter_values &&
          institution &&
          institution.internal_use_id == 'duoc.cl'
        "
      >
        <template v-for="environment in selectedStudyEnvironmentsOldMatter">
          <div :key="environment.id + 'old_matter'" class="table-cell d-flex">
            <div class="primary-cell w-50">
              N° EST. {{ environment.name.toUpperCase() }}
            </div>
            <div class="secundary-cell secundary-table1 w-50">
              {{ getEnvironmentStudentsOldMatter(environment.id) }}
            </div>
          </div>
        </template>
      </template>

      <!-- Estudiantes por Ambiente de Aprendizaje Matter-->
      <template
        v-if="
          Matter &&
          selectedStudyEnvironmentsMatter.length > 0 &&
          Matter &&
          !Matter.use_matter_values &&
          institution &&
          institution.internal_use_id == 'duoc.cl'
        "
      >
        <template v-for="environment in selectedStudyEnvironmentsMatter">
          <div :key="environment.id + 'matter'" class="table-cell d-flex">
            <div class="primary-cell w-50">
              N° EST. {{ environment.name.toUpperCase() }}
            </div>
            <div class="secundary-cell secundary-table1 w-50">
              {{ getEnvironmentStudentsMatter(environment.id) }}
            </div>
          </div>
        </template>
      </template>

      <!-- Fila 5 -->

      <!-- Total de Horas Pedagógicas UNAB Semanales-->
      <div
        class="table-cell d-flex"
        v-if="institution && institution.internal_use_id == 'unab.cl'"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_pedagogical_hours",
              true,
              "Total de Horas Pedagógicas"
            ).toUpperCase()
          }}
          {{ $t("matterProgram.matterProgramView.weekly").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="Matter && !Matter.use_matter_values && totalPedagogical">
            <span v-if="Matter.weeks > 0">
              {{ parseFloat((totalPedagogical / Matter.weeks).toFixed(2)) }}
            </span>
            <span v-else>0</span>
          </div>
          <div v-else>
            <span v-if="oldMatter.weeks">
              {{ parseFloat((totalPedagogical / oldMatter.weeks).toFixed(2)) }}
            </span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
      <!-- Total de Horas Pedagógicas (En Cronológicas) UNAB Semanales-->
      <div
        class="table-cell d-flex"
        v-if="institution && institution.internal_use_id == 'unab.cl'"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_pedagogical_hours_to_chronological",
              true,
              "Total de Horas Pedagógicas (En Cronológicas)"
            ).toUpperCase()
          }}
          {{ $t("matterProgram.matterProgramView.weekly").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <div
            v-if="
              Matter &&
              !Matter.use_matter_values &&
              profileType &&
              totalPedagogical
            "
          >
            <span v-if="Matter.weeks > 0">
              {{
                parseFloat(
                  (totalPedagogicalToChronological / Matter.weeks).toFixed(2)
                )
              }}
            </span>
            <span v-else>0</span>
          </div>
          <div v-else>
            <span v-if="oldMatter.weeks && profileType">
              {{
                parseFloat(
                  (totalPedagogicalToChronological / oldMatter.weeks).toFixed(2)
                )
              }}
            </span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
      <!-- Total de Horas Cronológicas Semanales-->
      <div
        class="table-cell d-flex"
        v-if="institution && institution.internal_use_id == 'unab.cl'"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_chronological_hours",
              true,
              "Total de Horas Cronológicas"
            ).toUpperCase()
          }}
          {{ $t("matterProgram.matterProgramView.weekly").toUpperCase() }}
        </div>
        <div class="secundary-cell w-50">
          <div
            v-if="
              Matter &&
              !Matter.use_matter_values &&
              profileType &&
              totalChronological
            "
          >
            <span v-if="Matter.weeks > 0">
              {{ parseFloat((totalChronological / Matter.weeks).toFixed(2)) }}
            </span>
            <span v-else>0</span>
          </div>
          <div v-else>
            <span v-if="oldMatter.weeks">
              {{
                parseFloat((totalChronological / oldMatter.weeks).toFixed(2))
              }}
            </span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
      <!-- Total de Horas Pedagógicas UNAB-->
      <div
        class="table-cell d-flex"
        v-if="institution && institution.internal_use_id == 'unab.cl'"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_pedagogical_hours",
              true,
              "Total de Horas Pedagógicas"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="totalPedagogical">
            {{ totalPedagogical }}
          </div>
        </div>
      </div>
      <!-- Total de Horas Pedagógicas (En Cronológicas) -->
      <div v-if="showPedagogicalHours" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_pedagogical_hours",
              true,
              "Total de Horas Pedagógicas"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="totalPedagogical">{{ totalPedagogical }}</span>
          <!-- Se Comenta por que quieren visualizar solo las Horas Pedagogicas en vez de las Cronologicas (26-08-2024) -->
          <!-- <span v-if="profileType && totalPedagogical">
            {{ totalPedagogicalToChronological }}
          </span> -->
        </div>
      </div>
      <!-- Total de Horas Cronológicas -->
      <div v-if="showChronologicalHours" class="table-cell d-flex">
        <div
          v-if="institution && institution.internal_use_id == 'duoc.cl'"
          class="primary-cell w-50"
        >
          {{
            $t(
              "matterProgram.matterProgramView.autonomousWorkHours"
            ).toUpperCase()
          }}
        </div>
        <div v-else class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_chronological_hours",
              true,
              "Total de Horas Cronológicas"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          {{ totalChronological }}
        </div>
      </div>
      <!-- Créditos SCT Totales -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.credits",
              true,
              "Créditos SCT Totales"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="Matter && !Matter.use_matter_values">
            <span>
              {{ Matter.credits }}
            </span>
          </div>
          <div v-else>
            <span>{{ oldMatter.credits }}</span>
          </div>
        </div>
      </div>
      <!-- Créditos Institucionales -->
      <div
        v-if="
          $hasInstitutionalCredits(institution)
        "
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.institutional_credits",
              true,
              "Créditos Institucionales"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="Matter && !Matter.use_matter_values">
            <span>
              {{ Matter.institutional_credits }}
            </span>
          </div>
          <div v-else>
            <span>
              {{ oldMatter.institutional_credits }}
            </span>
          </div>
        </div>
      </div>
      <!-- Fila 6 -->

      <!-- Ambiente de Aprendizaje  -->
      <div
        v-if="institution && institution.show_study_environment_menu"
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.studyenvironment",
              false,
              "Ambiente de Aprendizaje"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getMatterStudyEnvironments.length > 0">
            <span>
              {{ getMatterStudyEnvironments.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>{{ $t("reusable.common.notApplicable") }}</div>
          </template>
        </div>
      </div>
      <!-- Modalidad de Asignatura -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.modality",
              false,
              "Modalidad de Asignatura"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getModalities.length > 0">
            <span>
              {{ getModalities.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>{{ $t("reusable.common.notApplicable") }}</div>
          </template>
        </div>
      </div>
      <!-- Fecha de Publicación -->
      <div
        v-if="
          institution &&
          institution.internal_use_id == 'duoc.cl' &&
          Matter &&
          Matter.use_matter_values &&
          old_matter
        "
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $t("matterProgram.matterProgramView.publicationDate").toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="allows_crud && !old_matter.is_closed" class="w-100">
            <b-form-datepicker
              v-model="old_matter.publish_date"
              :disabled="old_matter.is_closed"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              @input="changePublishDate()"
              locale="es"
              size="sm"
              boundary="viewport"
            ></b-form-datepicker>
          </div>
          <div v-else class="ml-3">
            {{ old_matter.publish_date | FormatToDate }}
          </div>
        </div>
      </div>
      <!-- Estado del PMD  -->
      <div
        v-if="
          old_matter && institution && institution.internal_use_id == 'duoc.cl'
        "
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{ $t("matterProgram.matterProgramView.pmdStatus").toUpperCase() }}
        </div>
        <div class="secundary-cell-state w-50">
          <span
            :class="{
              'state-no-initiate':
                learningExperiences.length == 0 && allows_crud,
            }"
            v-if="
              learningExperiences.length == 0 && old_matter.is_closed == false
            "
          >
            {{ $t("matterProgram.matterProgramView.notStarted") }}
          </span>
          <span
            :class="{
              'state-initiate': learningExperiences.length > 0 && allows_crud,
            }"
            v-else-if="
              learningExperiences.length > 0 && old_matter.is_closed == false
            "
          >
            {{ $t("matterProgram.matterProgramView.inProgress") }}
          </span>
          <span
            :class="{
              'state-closed': old_matter.is_closed == true && allows_crud,
            }"
            v-else-if="old_matter.is_closed == true"
          >
            {{ $t("matterProgram.matterProgramView.completed") }}
          </span>
        </div>
      </div>
    </div>
    <!-- Vista Desktop -->
    <div class="table2-container desktop-view" v-if="visibleMatterHours.length > 0">
      <div class="items-activity">
        <div class="column title-table2">
          {{ $t("matterProgram.matterProgramView.activityType").toUpperCase() }}
        </div>
        <div
          class="column title-column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == true
          )"
          :key="'column1' + item.id"
        >
          {{ item.name.toUpperCase() }}
        </div>
        <div
          class="column title-column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == false
          )"
          :key="'column1.1' + item.id"
        >
          {{ item.name.toUpperCase() }}
        </div>
      </div>
      <div class="row2">
        <div class="column items-activity title-table2">
          <div>
            {{ $t("matterProgram.matterProgramView.totalHours").toUpperCase() }}
          </div>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == true
          )"
          :key="'column2' + item.id"
        >
          <div
            class="result-hours d-flex"
            :class="{
              'hours-div': item.counts_towards_credits,
              'hours-2-div': !item.counts_towards_credits,
            }"
          >
            <span
              v-b-tooltip.v-secondary.noninteractive="
                item.counts_towards_credits
                  ? $t('matterProgram.matterProgramView.includeInCountable', {
                      entity: $getVisibleNames(
                        'manual.total_pedagogical_hours',
                        true,
                        'Total de Horas Pedagógicas'
                      ),
                    })
                  : $t(
                      'matterProgram.matterProgramView.notIncludeInCountable',
                      {
                        entity: $getVisibleNames(
                          'manual.total_pedagogical_hours',
                          true,
                          'Total de Horas Pedagógicas'
                        ),
                      }
                    )
              "
            >
              {{ item.hours }}
            </span>
          </div>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == false
          )"
          :key="'column2.1' + item.id"
        >
          <div
            class="result-hours d-flex"
            :class="{
              'hours-div': item.counts_towards_credits,
              'hours-2-div': !item.counts_towards_credits,
            }"
          >
            <span
              v-b-tooltip.v-secondary.noninteractive="
                item.counts_towards_credits
                  ? $t('matterProgram.matterProgramView.includeInCountable', {
                      entity: $getVisibleNames(
                        'manual.total_chronological_hours',
                        true,
                        'Total de Horas Cronológicas'
                      ),
                    })
                  : $t(
                      'matterProgram.matterProgramView.notIncludeInCountable',
                      {
                        entity: $getVisibleNames(
                          'manual.total_chronological_hours',
                          true,
                          'Total de Horas Cronológicas'
                        ),
                      }
                    )
              "
            >
              {{ item.hours }}
            </span>
          </div>
        </div>
      </div>
      <div class="row3">
        <div class="column items-activity title-table2">
          <div>
            {{
              $t(
                "matterProgram.matterProgramView.attendanceRequirement"
              ).toUpperCase()
            }}
          </div>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == true
          )"
          :key="'column3' + item.id"
        >
          <span
            v-if="
              item.attendance_requirement != '' &&
              item.attendance_requirement != null &&
              item.attendance_requirement != 0
            "
            >{{ item.attendance_requirement }}%
          </span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == false
          )"
          :key="'column3.1' + item.id"
        >
          <span
            v-if="
              item.attendance_requirement != '' &&
              item.attendance_requirement != null &&
              item.attendance_requirement != 0
            "
            >{{ item.attendance_requirement }}%
          </span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
      </div>
      <div v-if="showStudentsCount" class="row4">
        <div class="column items-activity title-table2">
          <div>
            {{
              $t("matterProgram.matterProgramView.studentsPerHour").toUpperCase()
            }}
          </div>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == true
          )"
          :key="'column4' + item.id"
        >
          <span v-if="item.students_per_hour > 0">{{
            item.students_per_hour
          }}</span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
        <div
          class="column"
          v-for="item in visibleMatterHours.filter(
            (x) => x.uses_module_minutes == false
          )"
          :key="'column4.1' + item.id"
        >
          <span v-if="item.students_per_hour > 0">{{
            item.students_per_hour
          }}</span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
      </div>
    </div>

    <!-- Vista Mobile -->
    <div class="table2-container mobile-view" v-if="visibleMatterHours.length > 0">
      <!-- Primera fila -->
      <div class="row">
        <div class="column title-mobile items-activity">
          {{ $t("matterProgram.matterProgramView.activityType").toUpperCase() }}
        </div>
        <div class="column items-activity">
          {{ $t("matterProgram.matterProgramView.totalHours").toUpperCase() }}
        </div>
        <div class="column items-activity">
          {{
            $t(
              "matterProgram.matterProgramView.attendanceRequirement"
            ).toUpperCase()
          }}
        </div>
        <div v-if="showStudentsCount" class="column items-activity">
          {{
            $t("matterProgram.matterProgramView.studentsPerHour").toUpperCase()
          }}
        </div>
      </div>

      <!-- Segunda Fila -->
      <div
        class="row"
        v-for="item in visibleMatterHours.filter((x) => x.uses_module_minutes == true)"
        :key="'row' + item.id"
      >
        <div class="column title-mobile items-activity">
          {{ item.name.toUpperCase() }}
        </div>
        <div class="column">
          <div
            class="result-hours d-flex"
            :class="{
              'hours-div': item.counts_towards_credits,
              'hours-2-div': !item.counts_towards_credits,
            }"
          >
            <span
              v-b-tooltip.v-secondary.noninteractive="
                item.counts_towards_credits
                  ? $t('matterProgram.matterProgramView.includeInCountable', {
                      entity: $getVisibleNames(
                        'manual.total_pedagogical_hours',
                        true,
                        'Total de Horas Pedagógicas'
                      ),
                    })
                  : $t(
                      'matterProgram.matterProgramView.notIncludeInCountable',
                      {
                        entity: $getVisibleNames(
                          'manual.total_pedagogical_hours',
                          true,
                          'Total de Horas Pedagógicas'
                        ),
                      }
                    )
              "
            >
              {{ item.hours }}
            </span>
          </div>
        </div>
        <div class="column">
          <span
            v-if="
              item.attendance_requirement != '' &&
              item.attendance_requirement != null &&
              item.attendance_requirement != 0
            "
            >{{ item.attendance_requirement }}%
          </span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
        <div v-if="showStudentsCount" class="column">
          <span v-if="item.students_per_hour > 0">{{
            item.students_per_hour
          }}</span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
      </div>
      <div
        class="row"
        v-for="item in visibleMatterHours.filter(
          (x) => x.uses_module_minutes == false
        )"
        :key="'row1' + item.id"
      >
        <div class="column title-mobile items-activity">
          {{ item.name.toUpperCase() }}
        </div>
        <div class="column">
          <div
            class="result-hours d-flex"
            :class="{
              'hours-div': item.counts_towards_credits,
              'hours-2-div': !item.counts_towards_credits,
            }"
          >
            <span
              v-b-tooltip.v-secondary.noninteractive="
                item.counts_towards_credits
                  ? $t('matterProgram.matterProgramView.includeInCountable', {
                      entity: $getVisibleNames(
                        'manual.total_chronological_hours',
                        true,
                        'Total de Horas Cronológicas'
                      ),
                    })
                  : $t(
                      'matterProgram.matterProgramView.notIncludeInCountable',
                      {
                        entity: $getVisibleNames(
                          'manual.total_chronological_hours',
                          true,
                          'Total de Horas Cronológicas'
                        ),
                      }
                    )
              "
            >
              {{ item.hours }}
            </span>
          </div>
        </div>
        <div class="column">
          <span
            v-if="
              item.attendance_requirement != '' &&
              item.attendance_requirement != null &&
              item.attendance_requirement != 0
            "
            >{{ item.attendance_requirement }}%
          </span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
        <div v-if="showStudentsCount" class="column">
          <span v-if="item.students_per_hour > 0">{{
            item.students_per_hour
          }}</span>
          <span v-else> {{ $t("reusable.common.notApplicable") }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  toast,
  fetchMissingEgressProfileMattersAndMatters,
} from "@/utils/utils";

export default {
  name: "NewMatterPresentation",
  components: {
    PrerequisitesPopover: () =>
      import("@/components/reusable/PrerequisitesPopover"),
  },
  props: {
    oldMatter: {
      type: Object,
      required: true,
    },
    Matter: {
      type: [Object, null],
      required: false,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      old_matter: { ...this.oldMatter },
      default_bg_color: "#fff",
    };
  },
  computed: {
    ...mapGetters({
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      time_allocations: names.TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      studyEnvironmentsTimeAllocation: names.STUDY_ENVIRONMENTS_TIME_ALLOCATION,
      matters: names.MATTERS,
      user: "getUser",
      formationAreas: names.FORMATION_AREAS,
      formationLines: names.FORMATION_LINES,
      matterTypes: names.MATTER_TYPES,
      faculties: names.FACULTIES,
      matterContributions: names.MATTER_CONTRIBUTIONS,
      modalities: names.MODALITIES,
      egress_profiles: names.EGRESS_PROFILES,
      profile_types: names.PROFILE_TYPES,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      regimes: names.REGIMES,
      career: names.CAREERS,
      institution: "getInstitution",
      learningExperiences: names.LEARNING_EXPERIENCES,
      matter_study_environments: names.MATTER_STUDY_ENVIRONMENTS,
      egress_profile_matter_study_environments:
        names.EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS,
    }),
    showStudentsCount() {
      return this.$showsStudentsCount(this.institution);
    },
    env_students_old_matter() {
      if (!this.oldMatter) return [];
      return this.matter_study_environments.filter(
        (x) => x.matter == this.oldMatter.id
      );
    },
    env_students_matter() {
      if (!this.Matter) return [];
      return this.egress_profile_matter_study_environments.filter(
        (x) => x.egress_profile_matter == this.Matter.id
      );
    },
    selectedStudyEnvironmentsMatter() {
      // Filtra solo los ambientes que están seleccionados en matter
      if (!this.Matter.study_environments) return [];
      return this.studyEnvironments.filter((x) =>
        this.Matter.study_environments.includes(x.id)
      );
    },
    selectedStudyEnvironmentsOldMatter() {
      // Filtra solo los ambientes que están seleccionados en old_matter
      if (!this.oldMatter.study_environments) return [];
      return this.studyEnvironments.filter((x) =>
        this.oldMatter.study_environments.includes(x.id)
      );
    },
    showPedagogicalHours() {
      return (
        this.time_allocations.filter((x) => x.uses_module_minutes == true)
          .length > 0
      );
    },
    showChronologicalHours() {
      return (
        this.time_allocations.filter((x) => x.uses_module_minutes == false)
          .length > 0
      );
    },
    numberTableHeader() {
      let column = 11;
      // Nombre, Codigo, Semanas, N° Docentes, N° Estudiantes, Área de Formación, Tipo de Asignatura,
      // Total de Horas Pedagógicas (En Cronológicas), Total de Horas Cronológicas, Créditos SCT Totales
      // Modalidad de Asignatura,
      if (this.institution && this.institution.internal_use_id == "iacc.cl")
        column += 1; // Eximible
      if (this.Matter) column += 5; // Nivel de Plan, Prerrequisito, Perfil de Egreso, Linea de Formacion, Régimen
      if (this.institution && this.institution.show_study_environment_menu)
        column += 1; // Ambiente de Aprendizaje
      if (this.institution && this.institution.internal_use_id == "unab.cl")
        column += 4;
      //Total de Horas Pedagógicas UNAB Semanales, Total de Horas Pedagógicas (En Cronológicas) UNAB Semanales
      //Total de Horas Cronológicas Semanales, Total de Horas Pedagógicas UNAB,
      if (
        this.$hasInstitutionalCredits(this.institution)
      )
        column += 1; // Créditos Institucionales
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.Matter &&
        this.Matter.use_matter_values &&
        this.old_matter
      )
        column += 1; // Fecha de Publicación
      return column;
    },
    isPairNumberTableHeader() {
      return this.numberTableHeader % 2 == 0;
    },
    faculty() {
      if (!this.careerFilter) return null;
      return this.faculties.find((x) => x.id == this.careerFilter.faculty);
    },
    careerFilter() {
      if (!this.egressProfile) return null;
      return this.career.find((x) => x.id == this.egressProfile.career);
    },
    egressProfile() {
      if (this.Matter && !this.Matter.egress_profile) return [];
      return this.egress_profiles.find(
        (x) => x.id == this.Matter.egress_profile
      );
    },
    getFormationLine() {
      let formation_line = { name: this.$t("reusable.common.notApplicable") };
      if (!this.Matter) return formation_line;
      return (
        this.formationLines.find((x) => this.Matter.formation_line == x.id) ||
        formation_line
      );
    },
    timeAllocationsIds() {
      if (this.Matter && !this.Matter.use_matter_values) {
        if (this.Matter.study_environments.length == 0)
          return this.time_allocations.map((x) => x.id);
        return [
          ...new Set(
            this.studyEnvironmentsTimeAllocation
              .filter((x) =>
                this.Matter.study_environments.includes(x.study_environment)
              )
              .map((x) => x.time_allocation)
          ),
        ];
      } else {
        if (this.oldMatter.study_environments.length == 0)
          return this.time_allocations.map((x) => x.id);
        return [
          ...new Set(
            this.studyEnvironmentsTimeAllocation
              .filter((x) =>
                this.oldMatter.study_environments.includes(x.study_environment)
              )
              .map((x) => x.time_allocation)
          ),
        ];
      }
    },
    getFormationAreas() {
      let formation_area = {
        name: this.$t("reusable.common.notApplicable"),
      };
      if (!this.Matter) return formation_area;
      return (
        this.formationAreas.find((x) => x.id == this.Matter.formation_area) ||
        formation_area
      );
    },
    getMatterType() {
      let matter_types_ids = [];
      // PUCV: el tipo varía por plan, siempre se lee de la Asignatura del Perfil.
      if (
        this.Matter &&
        (!this.Matter.use_matter_values ||
          this.$usesEgressProfileMatterTypes(this.institution))
      )
        matter_types_ids = this.Matter.matter_types;
      else if (this.oldMatter) matter_types_ids = this.oldMatter.matter_types;
      return this.matterTypes.filter((x) => matter_types_ids.includes(x.id));
    },
    getEgressProfile() {
      const instance = this.egress_profiles.find(
        (x) => x.id == this.Matter.egress_profile
      );
      let arr = [];
      if (instance) {
        if (instance.code.trim() != "") arr.push(instance.code);
        if (instance.init_date) arr.push(instance.init_date);
        if (instance.professional_title.trim() != "")
          arr.push(instance.professional_title);
        return arr.join(" - ");
      } else return null;
    },
    getRegimen() {
      if (!this.Matter) return [];
      const get_regime = this.regimes.find((x) => x.id == this.Matter.regime);
      return get_regime
        ? get_regime
        : { name: this.$t("reusable.common.notApplicable") };
    },
    getModalities() {
      if (!this.Matter && !this.oldMatter) return [];
      let modalities_ids = [];
      if (this.Matter && !this.Matter.use_matter_values)
        modalities_ids = this.Matter.modalities;
      else modalities_ids = this.oldMatter.modalities;
      return this.modalities.filter((x) => modalities_ids.includes(x.id));
    },
    getMatterStudyEnvironments() {
      if (!this.Matter && !this.oldMatter) return [];
      let study_environments_ids = [];
      if (this.Matter && !this.Matter.use_matter_values)
        study_environments_ids = this.Matter.study_environments;
      else study_environments_ids = this.oldMatter.study_environments;
      return this.studyEnvironments.filter((x) =>
        study_environments_ids.includes(x.id)
      );
    },
    matterFormationLine() {
      if (!this.Matter) return this.default_bg_color;
      const formation_line = this.formationLines.find(
        (x) =>
          x.id == this.Matter.formation_line &&
          this.careerFilter &&
          x.faculties.includes(this.careerFilter.faculty)
      );
      if (formation_line) return formation_line.color;
      else return this.default_bg_color;
    },
    prerequisites() {
      let results = [];
      if (!this.Matter) return results;
      this.Matter.prerequisites.forEach((element) => {
        let egress_profile_matter = this.egress_profiles_matters.find(
          (x) => x.id == element
        );
        if (egress_profile_matter) {
          let instance = this.matters.find(
            (x) => x.id == egress_profile_matter.matter
          );
          if (instance) {
            let obj = {
              name: instance.name,
              code: egress_profile_matter.effective_code,
              order: egress_profile_matter.order,
            };
            results.push(obj);
          }
          return results.sort(function (a, b) {
            if (a.order > b.order) return 1;
            if (a.order < b.order) return -1;

            return 0;
          });
        }
      });
      return results;
    },
    prerequisitesNames() {
      let list = [];
      this.Matter.prerequisites.forEach((element) => {
        let egress_profile_matter = this.egress_profiles_matters.find(
          (x) => x.id == element
        );
        if (egress_profile_matter) {
          let instance = this.matters.find(
            (x) => x.id == egress_profile_matter.matter
          );

          if (instance) {
            list.push({
              ...instance,
              formation_line: egress_profile_matter.formation_line,
              order: egress_profile_matter.order,
              code: egress_profile_matter.effective_code,
            });
          }
        }
      });
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;

        return 0;
      });
    },
    totalPedagogical() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == true)
        .forEach((element) => {
          if (
            element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
    totalPedagogicalToChronological() {
      if (!this.profileType) return 0;
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0
      ) {
        return parseFloat(
          Math.round(
            this.totalPedagogical *
              (parseFloat(this.profileType.module_minutes) / 60)
          )
        );
      } else
        return parseFloat(
          (
            this.totalPedagogical *
            (parseFloat(this.profileType.module_minutes) / 60)
          ).toFixed(
            this.institution &&
              parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2
          )
        );
    },
    totalChronological() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == false)
        .forEach((element) => {
          if (
            element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
    // totalHours() {
    //   if (!this.profileType) return 0;
    //   const total_hours =
    //     this.totalPedagogical * (this.profileType.module_minutes / 60) +
    //     this.totalChronological;
    //   return total_hours ? total_hours : 0;
    // },
    profileType() {
      if (!this.Matter && this.oldMatter) {
        if (this.institution && this.institution.module_minutes > 0)
          return { module_minutes: this.institution.module_minutes };
        else return { module_minutes: 60 };
      } else {
        if (!this.egressProfile) return { module_minutes: 60 };
        return this.profile_types.find(
          (x) => x.id == this.egressProfile.egress_profile_type
        );
      }
    },
    matterHours() {
      let list = [];
      this.time_allocations.forEach((element) => {
        if (this.Matter && !this.Matter.use_matter_values) {
          const matter_hour = this.ep_matter_time_allocations.find(
            (x) =>
              x.egress_profile_matter == this.Matter.id &&
              x.time_allocation == element.id
          );
          if (
            matter_hour &&
            (this.timeAllocationsIds.includes(matter_hour.time_allocation) ||
              !element.has_study_environments ||
              matter_hour.hours > 0 ||
              matter_hour.tem_hours > 0)
          )
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              has_study_environments: element.has_study_environments,
              egress_profile_matter: matter_hour.egress_profile_matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              students_per_hour: matter_hour.students_per_hour,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.Matter.weeks) > 0
                  ? parseFloat(
                      (
                        parseFloat(matter_hour.hours) /
                        parseFloat(this.Matter.weeks)
                      ).toFixed(2)
                    )
                  : 0,
            });
        } else {
          const matter_hour = this.matter_time_allocations.find(
            (x) =>
              x.matter == this.oldMatter.id && x.time_allocation == element.id
          );
          if (
            matter_hour &&
            this.oldMatter &&
            (this.timeAllocationsIds.includes(matter_hour.time_allocation) ||
              !element.has_study_environments ||
              matter_hour.hours > 0 ||
              matter_hour.tem_hours > 0)
          )
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              has_study_environments: element.has_study_environments,
              matter: matter_hour.matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              students_per_hour: matter_hour.students_per_hour,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.oldMatter.weeks) > 0
                  ? parseFloat(
                      (
                        parseFloat(matter_hour.hours) /
                        parseFloat(this.oldMatter.weeks)
                      ).toFixed(2)
                    )
                  : 0,
            });
        }
      });
      return list;
    },
    visibleMatterHours() {
      // Las filas de total, exigencia y N° de estudiantes recorren esta misma lista,
      // así que filtrarla oculta la columna completa.
      // UDALBA: solo tipos de hora con horas > 0.
      if (this.$showsOnlyNonZeroTimeAllocations(this.institution))
        return this.matterHours.filter((x) => parseFloat(x.hours) > 0);
      // PUCV: tipos de hora con algún dato (horas, exigencia o N° de estudiantes).
      if (this.$showsOnlyFilledTimeAllocations(this.institution))
        return this.matterHours.filter(
          (x) =>
            parseFloat(x.hours) > 0 ||
            x.attendance_requirement > 0 ||
            x.students_per_hour > 0
        );
      return this.matterHours;
    },
  },
  methods: {
    // Matter.prerequisites son ids de egress-profile-matter, que pueden
    // pertenecer a otro perfil de egreso (transversales).
    fetchPrerequisites() {
      fetchMissingEgressProfileMattersAndMatters(this.Matter.prerequisites);
    },
    changePublishDate() {
      if (this.old_matter) {
        this.patchOldMatter({ publish_date: this.old_matter.publish_date });
        toast(
          this.$t("matterProgram.matterProgramView.publicationDateUpdated")
        );
      }
    },
    patchOldMatter(item) {
      if (this.old_matter)
        this.$store
          .dispatch(names.PATCH_MATTER, {
            matter_id: this.old_matter.id,
            item: item,
          })
          .then((response) => {
            this.old_matter = response;
          });
    },
    getEnvironmentStudentsOldMatter(environmentId) {
      // Buscar en el array de ambientes de old_matter desde el store
      const env = this.env_students_old_matter.find(
        (item) => item.study_environment == environmentId
      );
      return env ? env.suggested_students : 0;
    },
    getEnvironmentStudentsMatter(environmentId) {
      // Buscar en el array de ambientes de matter desde el store
      const env = this.env_students_matter.find(
        (item) => item.study_environment == environmentId
      );
      return env ? env.suggested_students : 0;
    },
  },
  watch: {},
  mounted() {},
  created() {
    if (this.institution && this.institution.internal_use_id == "duoc.cl") {
      // Cargar datos de study environments desde el store
      this.$store.dispatch(names.FETCH_MATTER_STUDY_ENVIRONMENTS);
      this.$store.dispatch(
        names.FETCH_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS
      );
    }
    if (this.Matter && !isNaN(this.Matter.id)) {
      this.$store.dispatch(names.FETCH_EP_MATTER_TIME_ALLOCATIONS, {
        egress_profile_matter_id: this.Matter.id,
      });
      this.fetchPrerequisites();
      this.$store
        .dispatch(names.FETCH_EGRESS_PROFILE, this.Matter.egress_profile)
        .then((response) => {
          this.$store
            .dispatch(names.FETCH_CAREER, response.career)
            .then((career) => {
              this.$store.dispatch(names.FETCH_FACULTY, career.faculty);
            });
        });
    }
    if (this.oldMatter) {
      this.$store.dispatch(names.FETCH_MATTER_TIME_ALLOCATIONS, {
        matter_id: this.oldMatter.id,
      });
      this.$store.dispatch(names.FETCH_LEARNING_EXPERIENCES, this.oldMatter.id);
    }
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    this.$store.dispatch(names.FETCH_MATTER_CONTRIBUTIONS);
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
    this.$store.dispatch(names.FETCH_MODALITIES);
  },
};
</script>

<style scoped>
.campus-div {
  /* El color de fondo lo define la vista (color de la línea de formación) de
     forma dinámica; aquí solo el formato de pill según el estándar. */
  background-color: var(--kl-color-primary);
  border: 1px solid #949292;
  color: var(--kl-text-on-primary);
  width: auto;
  border-radius: var(--kl-radius-pill);
  margin: 0.1em 0.1em;
  min-width: 23px;
  max-width: auto;
  padding: var(--kl-chip-padding);
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
}
.campus-container {
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.state-no-initiate {
  color: red;
  font-weight: bold;
}
.state-initiate {
  color: rgba(255, 115, 0, 0.726);
  font-weight: bold;
}
.state-closed {
  color: green;
  font-weight: bold;
}
.title-presentation {
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  font-weight: bold;
}
.name-matter,
.code-matter {
  font-weight: bold;
}

.name-matter {
  color: white;
  background-color: var(--kl-fourth-color) !important;
  height: 100%;
}

.table-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-size: 10pt;
  margin-bottom: 20px;
  gap: 0px;
  /* Borde único: el contenedor pinta arriba/izquierda y cada celda pinta
     derecha/abajo, así no se duplican las líneas entre celdas. Borde estándar
     de tablas de la app (--kl-table-border). */
  border-top: 1px solid var(--kl-table-border);
  border-left: 1px solid var(--kl-table-border);
  border-radius: var(--kl-radius-md);
  overflow: hidden;
}

.table-cell {
  border-right: 1px solid var(--kl-table-border);
  border-bottom: 1px solid var(--kl-table-border);
}

.primary-cell {
  height: 100%;
  display: flex;
  padding-left: 1em;
  padding-right: 1em;
  align-items: center;
  /* Columna de etiquetas (header): azul medio + texto blanco. */
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
  text-align: start;
}

.secundary-cell {
  padding: 4px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  /* font-weight: 500; */
}
.secundary-cell-state {
  color: black !important;
  padding: 4px;
  margin: 0px !important;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.prerequisites-p {
  vertical-align: middle;
  margin: 7px 10px;
}

.secundary-table1 {
  justify-content: center;
}
.prerequisite-order {
  display: inline;
}
.prerequisite-code {
  display: none;
}
/* .campus-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  font-size: var(--thirth-font-size);
  text-align: center;
} */

/* Estilos del ultimo hijo para que ocupe todo el ancho */
/* .table-container-odd > :last-child {
  grid-column: span 3; 
  display: grid;
}
.table-container-odd > :last-child .secundary-cell {
  justify-content: flex-start;
  text-align: left;
  width: 83.35% !important;
}
.table-container-odd > :last-child .primary-cell {
  justify-content: flex-start;
  width: 16.65% !important;
} */
@media (max-width: 1100px) {
  .table-container {
    grid-template-columns: repeat(2, 1fr);
  }
  /* .table-container-odd > :last-child {
    grid-column: span 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .table-container-odd > :last-child .secundary-cell {
    width: 100% !important;
    justify-content: center !important;
  }
  .table-container-odd > :last-child .primary-cell {
    justify-content: left;
    width: 96.3% !important;
  } */
}
@media (max-width: 750px) {
  .table-container {
    grid-template-columns: repeat(1, 1fr);
  }
  .title-presentation {
    flex-direction: column;
    align-items: center;
  }

  .school-title,
  .program-title {
    width: 100%;
    text-align: center;
  }
  .school-title {
    margin-bottom: 1rem;
  }

  /* .table-container-odd > :last-child {
    grid-column: span 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .table-container-odd > :last-child .primary-cell,
  .table-container-odd > :last-child .secundary-cell {
    width: 100%;
  }
  .table-container-odd > :last-child .secundary-cell {
    justify-content: center !important;
  } */
}
@media print {
  .table-container-odd > :last-child {
    grid-column: span 2;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .table-container-odd > :last-child .primary-cell {
    justify-content: left;
    width: 24.9% !important;
  }
  .table-container-odd > :last-child .secundary-cell {
    justify-content: center !important;
    width: 75.1% !important;
  }
}

.hours-div {
  background-color: var(--kl-color-primary);
  color: var(--kl-text-on-primary);
  max-width: fit-content;
  line-height: 1;
  padding: var(--kl-chip-padding);
  border-radius: var(--kl-radius-pill);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  /* text-align: center; */
}
.hours-2-div {
  background-color: var(--kl-color-secondary);
  color: var(--kl-text-on-primary);
  max-width: fit-content;
  line-height: 1;
  padding: var(--kl-chip-padding);
  border-radius: var(--kl-radius-pill);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  /* text-align: center; */
}
/* Tabla 2 */

.table2-container {
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2em;
  font-size: 10pt;
}

.items-activity {
  /* Header del resumen: azul medio + texto blanco. */
  background-color: var(--kl-color-accent-medium) !important;
  display: table-row;
  color: var(--kl-text-on-primary) !important;
  font-weight: var(--kl-fw-bold);
}

.title-table2 {
  text-align: start !important;
  padding-left: 1em !important;
  padding-right: 1em !important;
  color: var(--kl-text-on-primary) !important;
  vertical-align: middle;
}

.row,
.row2,
.row3,
.row4 {
  display: table-row;
}

.mobile-view {
  display: none;
}

.result-hours {
  margin-left: auto;
  margin-right: auto;
}
.column {
  display: table-cell;
  padding: 4px;
  border: 1px solid var(--kl-table-border);
  color: var(--kl-text-body);
  vertical-align: middle;
}

.title-column {
  color: var(--kl-text-on-primary) !important;
  vertical-align: middle;
}

@media screen and (max-width: 800px) {
  .desktop-view {
    display: none;
  }
  .mobile-view {
    display: table;
  }
  .title-mobile {
    text-align: start !important;
    padding-left: 2em !important;
  }
}
@media print {
  .table-container {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .prerequisite-order {
    display: none;
  }
  .prerequisite-code {
    display: inline;
  }
}
</style>
